import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";

const inputCls =
  "w-full border border-slate-300 rounded-md px-3 py-2 text-sm text-slate-700 placeholder-slate-400 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none bg-white";

export default function PalletsCard({ day, closed, onSave }) {
  const [form, setForm] = useState({ pallets: "", single: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm({
      pallets: day?.pallets != null ? String(day.pallets) : "",
      single: day?.single_items != null ? String(day.single_items) : "",
    });
  }, [day?.id, day?.pallets, day?.single_items]);

  const save = async () => {
    setSaving(true);
    try {
      await onSave({
        pallets: parseInt(form.pallets, 10) || 0,
        single_items: parseInt(form.single, 10) || 0,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-md shadow-sm p-4" data-testid="pallets-card">
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-1">
        Total Pallets Sent
      </div>
      <p className="text-sm text-slate-500 mb-4">
        Pallets and single items sent out from this location today.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-slate-500">Number of pallets</label>
          {closed ? (
            <div className="text-sm font-semibold text-emerald-700 mt-1" data-testid="pallets-value">
              {form.pallets || "0"}
            </div>
          ) : (
            <input
              data-testid="pallets-input"
              type="text"
              inputMode="numeric"
              value={form.pallets}
              onChange={(e) => setForm({ ...form, pallets: e.target.value.replace(/\D/g, "") })}
              placeholder="0"
              className={inputCls}
            />
          )}
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-500">Number of single items</label>
          {closed ? (
            <div className="text-sm font-semibold text-emerald-700 mt-1" data-testid="single-items-value">
              {form.single || "0"}
            </div>
          ) : (
            <input
              data-testid="single-items-input"
              type="text"
              inputMode="numeric"
              value={form.single}
              onChange={(e) => setForm({ ...form, single: e.target.value.replace(/\D/g, "") })}
              placeholder="0"
              className={inputCls}
            />
          )}
        </div>
      </div>
      {!closed && (
        <div className="flex justify-end mt-4">
          <Button
            data-testid="pallets-save-btn"
            onClick={save}
            disabled={saving}
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
          >
            <CheckCircle size={18} weight="bold" className="mr-2" />
            {saving ? "Saving..." : "Save"}
          </Button>
        </div>
      )}
    </div>
  );
}
